import React from 'react';
import { ListGroup } from 'reactstrap';

import ListGroupItem from '../../StudyList/ListGroupItem.jsx';

function ChapterStudyPlanView({
  chapterStudyPlan,
  userSubscription,
  setChapterId,
  getPdfByReference,
  onRebuild,
}) {
  if (!chapterStudyPlan) return null;

  const { this_week_focus, upcoming, completed, pdfUrl } = chapterStudyPlan;

  const handleDownload = () => {
    window.open(pdfUrl, '_blank');
  };

  return (
    <div className="chapter-study-plan-section">
      <div className="chapter-study-plan-section__divider">
        <span>CHAPTER STUDY PLAN</span>
      </div>
      <div className="mt-3 ml-3 mr-3">
        {this_week_focus && (
          <div className="d-flex align-items-center justify-content-between mb-2 chapter-list-view__plan-header">
            <h4>This Week&apos;s Focus</h4>
            <div className="d-flex" style={{ gap: '0.5rem' }}>
              {pdfUrl && (
                <button
                  type="button"
                  className="chapter-list-view__btn"
                  onClick={handleDownload}
                >
                  DOWNLOAD STUDY PLAN
                </button>
              )}
              <button
                type="button"
                className="chapter-list-view__btn"
                onClick={onRebuild}
              >
                REBUILD STUDY PLAN
              </button>
            </div>
          </div>
        )}
        {this_week_focus && (
          <ListGroup>
            <ListGroupItem
              userSubscription={userSubscription}
              {...this_week_focus}
              nextUpSectionIndex={(completed?.length ?? 0) + 1}
              setChapterId={setChapterId}
              getPdfByReference={getPdfByReference}
              isStudyPlan
            />
          </ListGroup>
        )}

        {upcoming?.length > 0 && (
          <div>
            <div className="d-flex align-items-center justify-content-between mb-2 chapter-list-view__plan-header">
              <h4>Upcoming</h4>
              {!this_week_focus && (
                <div className="d-flex" style={{ gap: '0.5rem' }}>
                  {pdfUrl && (
                    <button
                      type="button"
                      className="chapter-list-view__btn"
                      onClick={handleDownload}
                    >
                      DOWNLOAD STUDY PLAN
                    </button>
                  )}
                  <button
                    type="button"
                    className="chapter-list-view__btn mr-2"
                    onClick={onRebuild}
                  >
                    REBUILD STUDY PLAN
                  </button>
                </div>
              )}
            </div>
            {upcoming.map((item, index) => (
              <ListGroup key={item.id} className="mb-3">
                <ListGroupItem
                  userSubscription={userSubscription}
                  key={item.id}
                  {...item}
                  nextUpSectionIndex={(completed?.length ?? 0) + index + 2}
                  setChapterId={setChapterId}
                  getPdfByReference={getPdfByReference}
                  isStudyPlan
                />
              </ListGroup>
            ))}
          </div>
        )}

        {completed?.length > 0 && (
          <div className="mt-4">
            <h4>Completed</h4>
            {completed.map((item, index) => (
              <ListGroup key={item.id} className="mb-3">
                <ListGroupItem
                  userSubscription={userSubscription}
                  key={item.id}
                  {...item}
                  nextUpSectionIndex={index + 1}
                  setChapterId={setChapterId}
                  getPdfByReference={getPdfByReference}
                  isStudyPlan
                />
              </ListGroup>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default ChapterStudyPlanView;
